import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CallAPI from "../../services/apiCalls";
import useUserStore from "../../utils/storeApp";

const o = {
  Classification: "",
  Code: "",
  Definition: "",
  Id: "",
  Notes: "",
  Specialization: "",
  Type: "",
  SpecialtyTypeVal: "",
  SpecialtyclassificationVal: "",
  SpecialtySpecializationVal: "",
};

const SpecialtyDropdown = ({ SpecialFormFields, codes, editObj }) => {
  const { userRole, userToken, customerObj, sharedObject, SetSharedObject } =
    useUserStore((state) => ({
      userRole: state.userRole,
      userToken: state.userToken,
      customerObj: state.customerObj,
      sharedObject: state.sharedObject,
      SetSharedObject: state.SetSharedObject,
    }));
  const navigate = useNavigate();
  const [processing, SetProcessing] = useState(false);
  const [answers, setAnswers] = useState(o);
  const [obj2, setObj2] = useState([]);
  const [obj3, setObj3] = useState([]);
  const [tempObj, setTempObj] = useState(false);
  const [SpecialtyTypeVal, setSpecialtyTypeVal] = useState("");
  const [SpecialtyclassificationVal, setSpecialtyclassificationVal] =
    useState("");
  const [SpecialtySpecializationVal, setSpecialtySpecializationVal] =
    useState("");
  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  useEffect(() => {
    if (sharedObject.specialties) {
      setVals(editObj);
    }
    SpecialFormFields(answers);
  }, [editObj]);
  useEffect(() => {
    if (tempObj) {
      setSpecialtyTypeVal(tempObj.type);
      setSpecialtyclassificationVal(tempObj.classification);
      setSpecialtySpecializationVal(tempObj.code);
    }
  }, [tempObj]);
  const setVals = async (editObj) => {
    setObj2([]);
    setObj3([]);
    setSpecialtyTypeVal("");
    setSpecialtyclassificationVal("");
    setSpecialtySpecializationVal("");
    let val = editObj ? editObj[0] : null;
    if (val?.Type) {
      await getTypes("SpecialtyType", val?.Type);
    }
    if (val?.Classification && val?.Type) {
      await getTypes("Specialtyclassification", val?.Classification, val.Type);
    }
    if (val?.Code) {
      await getTypes("SpecialtySpecialization", val?.Code);
    }
  };

  const getTypes = async (type, vl, tp) => {
    let val = encodeURIComponent(vl);
    const o = {
      Classification: "",
      Code: "",
      Definition: "",
      Id: 0,
      Notes: "",
      Specialization: "",
      Type: "",
    };
    let secCall = tp ? tp : SpecialtyTypeVal;
    SetProcessing(true);
    let call = "";
    if (type === "SpecialtyType") {
      call = "/admin/Level2TexCodes?type=" + val;
      setObj2([]);
      setObj3([]);
      setSpecialtyTypeVal(vl);
      await SpecialFormFields({ ...o, Type: vl, SpecialityType: vl });
      await SetSharedObject("specialties", { ...o, Type: vl });
    } else if (type === "SpecialtySpecialization") {
      if (val === "") {
        await SetSharedObject("specialties", {
          ...sharedObject.specialties,
          Code: "",
          Id: 0,
          Notes: "",
          Definition: "",
          Specialization: "",
        });
      }
      call = "/admin/getSpecialty?code=" + val;
      setSpecialtySpecializationVal(vl);
    } else {
      setObj3([]);
      call =
        "/admin/Level3TexCodes?type=" +
        encodeURIComponent(secCall) +
        "&classification=" +
        val;
      //setSpecialtyTypeVal(secCall);
      setSpecialtyclassificationVal(vl);
      await SpecialFormFields({
        Type: secCall,
        Classification: vl,
        SpecialityType: secCall,
      });
      await SetSharedObject("specialties", {
        Type: secCall,
        SpecialityType: secCall,
        Classification: vl,
      });
    }
    if (val !== "") {
      const res = await CallAPI(call, false, "get", userToken);
      await SetSharedObject("ResponseCode", res.code);
      if (res.status === "SUCCESS") {
        let dt = res.data.data;
        if (type === "SpecialtyType") {
          setObj2(dt);
        } else if (type === "SpecialtySpecialization") {
          let codesObj = {
            ...answers,
            Type: dt?.type,
            SpecialityType: dt.type,
            Code: dt?.code,
            Classification: dt?.classification,
            Specialization: dt?.specialization,
            Id: dt?.id,
            Notes: dt?.notes,
            Definition: dt?.definition,
          };
          await SetSharedObject("specialties", codesObj);
          await SpecialFormFields(codesObj);
          setTempObj(dt);
        } else {
          setObj3(dt);
        }
      } else if (res.status === "SERVERERROR") {
        SetProcessing(false);
      }
    }
    SetProcessing(false);
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing]);

  return (
    <fieldset className="SpecialtyDropdown">
      <legend className="sr-only">Specialty Selection</legend>
      <div className="field-wrapper">
        <label htmlFor="SpecialtyType">Type</label>
        <select
          className="form-control"
          id="SpecialtyType"
          name="SpecialtyType"
          value={SpecialtyTypeVal}
          aria-describedby="specialtyTypeHint"
          onChange={(el) => getTypes("SpecialtyType", el.target.value)}
        >
          <option value="">Select</option>
          {sharedObject?.codes?.map((el) => (
            <option key={el.value} value={el.value}>
              {el.text}
            </option>
          ))}
        </select>
        <span id="specialtyTypeHint" className="sr-only">
          Selecting a type will load available classifications.
        </span>
      </div>

      <div className="field-wrapper">
        <label htmlFor="SpecialtyClassification">Classification</label>
        <select
          className="form-control"
          id="SpecialtyClassification"
          name="SpecialtyClassification"
          value={SpecialtyclassificationVal}
          disabled={obj2.length === 0}
          aria-disabled={obj2.length === 0}
          aria-describedby="specialtyClassificationHint"
          onChange={(el) =>
            getTypes("SpecialtyClassification", el.target.value)
          }
        >
          <option value="">Select</option>
          {obj2?.map((el) => (
            <option key={el.text} value={el.text}>
              {el.text}
            </option>
          ))}
          <span id="specialtyClassificationHint" className="sr-only">
            {obj2.length === 0
              ? "Select a type above to load classifications."
              : "Selecting a classification will load available specializations."}
          </span>
        </select>
      </div>
      <div className="field-wrapper">
        <label htmlFor="SpecialtySpecialization">Specialization</label>
        <select
          className="form-control"
          id="SpecialtySpecialization"
          name="SpecialtySpecialization"
          disabled={obj3.length === 0}
          aria-disabled={obj3.length === 0}
          aria-describedby="specialtySpecializationHint"
          value={SpecialtySpecializationVal}
          onChange={(el) => {
            getTypes("SpecialtySpecialization", el.target.value);
          }}
        >
          <option value="">Select</option>
          {obj3?.map((el) => (
            <option key={el.value} value={el.value}>
              {el.text}
            </option>
          ))}
        </select>
        <span id="specialtySpecializationHint" className="sr-only">
          {obj3.length === 0
            ? "Select a classification above to load specializations."
            : "Selecting a specialization will load available options."}
        </span>
      </div>
      {processing && (
        <div
          className="loader-container"
          role="status"
          aria-live="polite"
          aria-atomic="true"
          aria-labelledby="specialty-loader-text"
        >
          <div className="spinner" aria-hidden="true"></div>
          <div className="loading-text" id="specialty-loader-text">
            {loadingText}
          </div>
        </div>
      )}
    </fieldset>
  );
};

export default SpecialtyDropdown;
